import React, { Component } from 'react';
import LoadingOverlay from '../../components/loading/loading';
import { toast } from "react-toastify";
import service from '../../services/service';
import { IMAGE_PATH } from '../../config'

export default class EventForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            description: "",
            loading: false,
            updateFields: {},
            images: null,
            preview: null,
        };
    }

    getEventDetails = async () => {
        try {
            this.setState({ loading: true });
            const response = await service.view(`events/${this.props.event_id}`);
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            this.setState({
                title: response.event.title || "",
                description: response.event.description || "",
                images: response.event.images || null,
                preview: response.event.images ? IMAGE_PATH + response.event.images : null,
            });
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        if (this.props.event_id !== "false") {
            this.getEventDetails();
        }
    }

    changeHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.setState((prevState) => ({
            updateFields: {
                ...prevState.updateFields,
                [name]: value,
            },
        }));
    };

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({ images: file, preview: URL.createObjectURL(file) });
        }
    };

    submitHandler = async (e) => {
        e.preventDefault();
        try {
            this.setState({ loading: true });
            const event_id = this.props.event_id;

            const formData = new FormData();
            formData.append("title", this.state.title);
            formData.append("description", this.state.description);
            if (this.state.images) {
                formData.append("images", this.state.images);
            }

            if (event_id !== "false") {
                const response = await service.saveWithFile(formData, `events/${event_id}`, "PUT");
                if (response && !response.success) {
                    toast.error(response.message);
                    return;
                }
                toast.success(response.message);
            } else {
                const response = await service.saveWithFile(formData, "events/", "POST");
                if (response && !response.success) {
                    toast.error(response.message);
                    return;
                }
                toast.success(response.message);
                // Reset the state after success
                this.setState({
                    title: "",
                    description: "",
                    images: null,
                    preview: null,
                    updateFields: {},
                });
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { title, description, loading, preview } = this.state;
        return (
            <>
                {loading && <LoadingOverlay />}
                <form onSubmit={this.submitHandler} className="contact-form">
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold' }}>Title</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={title}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="title"
                                    placeholder="Event Title"
                                />
                            </div>
                        </div>
                        <div className="col-lg-8 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold' }}>Description</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={description}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="description"
                                    placeholder="Event Description"
                                />
                            </div>
                        </div>
                        <div className="col-lg-10 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold' }}>Upload Image</label>
                                <input type="file" accept="image/*" onChange={this.handleFileChange} />
                                {preview && (
                                    <img src={preview} alt="Preview" style={{ marginTop: "10px", maxWidth: "100%", height: "auto" }} />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-1 col-12 text-end">
                            <div className="form-field">
                                <button type="submit" className="theme-btn" style={{ padding: '10px 40px', marginTop: '28px' }}>
                                    {this.props.event_id !== "false" ? "Update" : "Add"}
                                </button>
                            </div>
                        </div>
                        {/* <div className="col-lg-10 col-12">
                            <div className="form-field">
                                {images && typeof images === 'string' && (
                                    <img src={images} alt="Uploaded" style={{ marginTop: "10px", maxWidth: "100%", height: "auto" }} />
                                )}
                            </div>
                        </div> */}
                    </div>
                </form>
            </>
        );
    }
}
